export default {
    token: null
}